<script>
import dayjs from "dayjs";
import VTime from "@/components/Clockin/VTime";

export default {
    props: {
        logs: {},
        year: {},
        month: {},
        day: {}
    },
    components: { VTime },
    computed: {
        entry() {
            return this.logs[this.fmt(this.year, this.month, this.day)];
        }
    },
    methods: {
        fmt(y, m, d) {
            return dayjs(`${y}-${m}-${d}`).format("YYYY-MM-DD");
        }
    }
};
</script>

<template>
    <div
        :class="{
            'text-warning': entry['daylog']['status'] === 1
        }"
    >
        <i class="far fa-clock fa-fw"></i>

        <template
            v-if="
                entry['daylog']['time_stop'] === null &&
                    entry['daylog']['time_start'] === null
            "
        >
            ---</template
        >
        <template
            v-else-if="
                entry['daylog']['time_stop'] === null ||
                    entry['daylog']['time_start'] === null
            "
        >
            <v-time :time="entry['daylog']['time_start']" /> -
            <i class="far fa-question-square"></i>
        </template>
        <template v-else>
            <v-time :time="entry['daylog']['time_start']" />
            -
            <v-time
                v-if="entry['daylog']['time_stop']"
                :time="entry['daylog']['time_stop']"
            />
        </template>
    </div>
</template>
